import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

/* eslint-disable-next-line import/prefer-default-export */
export function assignInvitation(user_email) {
  return Vue.axios({
    method: "post",
    url: `${siteConfig.siteURL}user_invitations/${user_email}/invite`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
